import type { Mint } from "@solana/spl-token0.3.8";
import { useConnection } from "@solana/wallet-adapter-react";
import type { PublicKey } from "@solana/web3.js";
import { useEffect, useState } from "react";

import { cache } from "../../utils/cache";

export function useMint(key?: string | PublicKey) {
  const { connection } = useConnection();
  const [mint, setMint] = useState<Mint>();

  const id = typeof key === "string" ? key : key?.toBase58();

  useEffect(() => {
    if (!id) {
      return;
    }

    cache
      .queryMint(connection, id)
      .then((mint) => {
        setMint(mint.info);
      })
      .catch((err) => console.error(err));

    const dispose = cache.emitter.onCache((e) => {
      const event = e;
      if (event.id === id) {
        void cache.queryMint(connection, id).then((mint) => {
          setMint(mint.info);
        });
      }
    });
    return () => {
      dispose();
    };
  }, [connection, id]);

  return mint;
}
